import { useEffect, useState } from 'react'
import { useAuth } from '../../../../modules/auth'
import db from '../../../../../services/firebase'
import { collection, doc, onSnapshot } from 'firebase/firestore'
import SignupReferral from '../../../../modules/auth/modals/SignupReferal'
import { Link } from 'react-router-dom'

const DashboardHeader = () => {
  const { currentUser } = useAuth()
  const [totalTest, setTotalTests] = useState(0)
  const [passingTests, setPassingTests] = useState(0)
  const [failingTests, setFailingTests] = useState(0)
  const [controls, setControls] = useState<any[]>([])
  const [totalControl, setTotalcontrols] = useState(0)
  const [healthyControlsCount, setHealthyControlsCount] = useState(0)
  const [unhealthyControlsCount, setUnhealthyControlsCount] = useState(0)
  const [activeFrameworks, setActiveFrameworks] = useState<any[]>([])
  const [showSignupReferral, setShowSignupReferral] = useState(false)
  const [totalPolicy, setTotalPolicy] = useState(0)
  const [totalPolicyApproval, setTotalPolicyApproval] = useState(0)


  useEffect(() => {
    const isNewUser = localStorage.getItem('isNewUser')
    if (isNewUser === 'true') {
      setShowSignupReferral(true)
      localStorage.removeItem('isNewUser')
    }
  }, [])

  useEffect(() => {
    if (currentUser?.tenantId) {
      getActiveFramworks()
    }
  }, [currentUser])

  useEffect(() => {
    if (currentUser?.tenantId) {
      getTests()
      getControls()
    }
  }, [activeFrameworks, currentUser])

  const getTests = () => {
    try {
      const tenantId = currentUser?.tenantId || ''
      if (!tenantId) return;
      
      const tenantRef = doc(db, 'tenants', tenantId)
      const testsCollectionRef = collection(tenantRef, 'tests')

      const unsubscribe = onSnapshot(testsCollectionRef, (snapshot) => {
        const testsData = snapshot.docs.map((doc) => ({
          ...doc.data(),
          id: doc.id,
          framework: doc.data().framework,
          status: doc.data().status,
        }))

        const filteredTests = testsData.filter((test) =>
          test.status !== 'Deactivated' && 
          activeFrameworks.some((framework) => test.framework && test.framework.includes(framework))
        )


        setTotalTests(filteredTests.length)

        const passingCount = filteredTests.filter((test) => test.status === 'Pass').length
        const failingCount = filteredTests.filter((test) => test.status === 'Fail').length

        setPassingTests(passingCount)
        setFailingTests(failingCount)
      })

      return unsubscribe
    } catch (error) {
      console.error('Error getting tests:', error)
    }
  }

  const getActiveFramworks = () => {
    try {
      const tenantId = currentUser?.tenantId || ''
      if (!tenantId) return;
      
      const tenantRef = doc(db, 'tenants', tenantId)

      const testsCollectionRef = collection(tenantRef, 'active_frameworks')

      const unsubscribe = onSnapshot(testsCollectionRef, (snapshot) => {
        const frameworksData = snapshot.docs.map((doc) => ({
          ...doc.data(),
          id: doc.id,
          frameworks: doc.data().frameworks,
        }))
        const frameworks = frameworksData[0]?.frameworks || []
        setActiveFrameworks(frameworks)
      })

      return unsubscribe
    } catch (error) {
      console.error('Error getting tests:', error)
    }
  }

  const getControls = () => {
    try {
      const tenantId = currentUser?.tenantId || ''
      if (!tenantId) return;
      const tenantRef = doc(db, 'tenants', tenantId)
      const testsCollectionRef = collection(tenantRef, 'controls')

      const unsubscribe = onSnapshot(testsCollectionRef, (snapshot) => {
        const controlsData = snapshot.docs.map((doc) => ({
          ...doc.data(),
          id: doc.id,
          framework: doc.data().control_framework_mappings,
          status: doc.data().control_evidence_status,
        }))

        const filteredControls = controlsData.filter((control) => {
          if (!control.framework) return false
          if (control.status === 'Deactivated') return false
          return activeFrameworks.some(
            (framework) =>
              control.framework.startsWith(framework) &&
              !control.framework.startsWith('ISO 27001:2013')
          )
        })

        setControls(filteredControls)

        setTotalcontrols(filteredControls.length)
      })

      return unsubscribe
    } catch (error) {
      console.error('Error getting controls:', error)
    }
  }

  useEffect(() => {
    if (!controls || controls.length === 0) {
      return
    }

    const HealthyControls = controls.filter((doc) => {
      const status = doc.control_evidence_status || ''
      return status.toLowerCase() === 'ok'
    })
    const HealthyControlsCount = HealthyControls.length
    setHealthyControlsCount(HealthyControlsCount)

    const unhealthyControls = controls.filter((doc) => {
      const status = doc.control_evidence_status

      return status && status === 'Unhealthy'
    })
    const unhealthyControlsCount = unhealthyControls.length

    setUnhealthyControlsCount(unhealthyControlsCount)

  }, [controls])


  useEffect(() => {
    const tenantId = currentUser?.tenantId || '';
    if (!tenantId) return;
    const tenantRef = doc(db, 'tenants', tenantId);
    const PolicyRef = collection(tenantRef, 'policies');

    const unsubscribe = onSnapshot(PolicyRef, (snapshot) => {
      const assetData = snapshot.docs.map((item) => ({
        ...item.data(),
        id: item.id,
        status: item.data().status,
        framework: item.data().frameworks
      }));

      const filteredControls = assetData.filter((policy) => {
        if (!policy.framework || !Array.isArray(policy.framework) || policy.framework.length === 0) {
          return false;
        }
        if (policy.status === 'Deactivated') {
          return false;
        }

        return policy.framework.some(frameworkItem =>
          activeFrameworks.some(activeFramework =>
            frameworkItem.startsWith(activeFramework) &&
            !frameworkItem.startsWith('ISO 27001:2013')
          )
        );
      });

      setTotalPolicy(filteredControls.length);

      const needApprovalCount = filteredControls.filter((data) => data.status === 'Approved');
      setTotalPolicyApproval(needApprovalCount.length);

    });

    return unsubscribe;
  }, [activeFrameworks, currentUser?.tenantId]);

  return (
    <>
      <SignupReferral show={showSignupReferral} onHide={() => setShowSignupReferral(false)} />
      <div className='row gx-4 gx-xl-10' style={{ marginBottom: '24px' }}>
        <div className='col-sm-4 '>
          <div className='card gap-3' style={{ padding: '24px' }}>
            <h3 className='card-title'>
              <span className='fw-bold fs-4 text-dark'>Controls</span>
            </h3>
            <div>
              <div className='d-flex justify-content-end mb-3'>
                <div className='d-flex flex-column w-100'>
                  <div className='d-flex justify-content-end fs-7 text-black mb-1'>
                    <span className='fw-semibold'>
                      {totalControl !== 0
                        ? `${((healthyControlsCount / totalControl) * 100).toFixed(0)}%`
                        : '0%'}{' '}
                      <span className='text-gray-800'>OK</span>
                    </span>
                  </div>
                  <div
                    className='h-12px w-100 rounded'
                    style={{ backgroundColor: 'rgb(229 231 235)' }}
                  >
                    <div
                      className='rounded h-8px'
                      role='progressbar'
                      style={{
                        width:
                          totalControl !== 0
                            ? `${Math.min(healthyControlsCount / totalControl) * 100}%`
                            : '0%',
                        backgroundColor: '#0E9F6E',
                      }}
                      aria-valuenow={
                        totalControl !== 0
                          ? Math.min((healthyControlsCount / totalControl) * 100, 100)
                          : 0
                      }
                      aria-valuemin={0}
                      aria-valuemax={100}
                    ></div>
                  </div>
                </div>
              </div>
              <div className='d-flex justify-content-between align-items-center mt-6'>
                <div className='d-flex align-items-center'>
                  <svg
                    xmlns='http://www.w3.org/2000/svg'
                    width='18'
                    height='18'
                    viewBox='0 0 24 24'
                    fill='none'
                    stroke='#5E6274'
                    strokeWidth='2'
                    strokeLinecap='round'
                    strokeLinejoin='round'
                    className='me-2'
                  >
                    <path stroke='none' d='M0 0h24v24H0z' fill='none' />
                    <path d='M14 6m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0' />
                    <path d='M4 6l8 0' />
                    <path d='M16 6l4 0' />
                    <path d='M8 12m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0' />
                    <path d='M4 12l2 0' />
                    <path d='M10 12l10 0' />
                    <path d='M17 18m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0' />
                    <path d='M4 18l11 0' />
                    <path d='M19 18l1 0' />
                  </svg>
                  <span className='text-gray-700 fw-semibold'>Total Controls</span>
                </div>
                <span className='text-gray-900 fw-bold'>{totalControl}</span>
              </div>

              <div className='d-flex justify-content-between align-items-center mt-4'>
                <div className='d-flex align-items-center'>
                  <svg
                    xmlns='http://www.w3.org/2000/svg'
                    width='18'
                    height='18'
                    viewBox='0 0 24 24'
                    fill='none'
                    stroke='#EE3043'
                    strokeWidth='2'
                    strokeLinecap='round'
                    strokeLinejoin='round'
                    className='me-2'
                  >
                    <path stroke='none' d='M0 0h24v24H0z' fill='none' />
                    <path d='M3 12a9 9 0 1 0 18 0a9 9 0 0 0 -18 0' />
                    <path d='M12 8v4' />
                    <path d='M12 16h.01' />
                  </svg>
                  <span className='text-gray-700 fw-semibold'>Unhealthy</span>
                </div>
                <span className='text-gray-900 fw-bold'>{unhealthyControlsCount}</span>
              </div>

              <div className='d-flex justify-content-between align-items-center mt-4'>
                <div className='d-flex align-items-center hover-group' style={{ cursor: 'pointer' }}>
                  <Link
                    to='/controls'
                    className='text-dark fw-medium text-decoration-underline hover-text hover-text-decoration-underline me-1'
                  >
                    View controls
                  </Link>
                  <svg
                    xmlns='http://www.w3.org/2000/svg'
                    width='14'
                    height='14'
                    viewBox='0 0 24 24'
                    fill='none'
                    stroke='currentColor'
                    strokeWidth='2'
                    strokeLinecap='round'
                    strokeLinejoin='round'
                    className='icon icon-tabler icons-tabler-outline icon-tabler-chevron-right transition-transform hover-effect'
                    style={{ transition: 'transform 0.2s ease-in-out' }}
                  >
                    <path stroke='none' d='M0 0h24v24H0z' fill='none' />
                    <path d='M9 6l6 6l-6 6' />
                  </svg>
                  <style>
                    {`
                      .hover-group:hover .hover-effect {
                        transform: translateX(3px);
                      }
                      .hover-group:hover .hover-text {
                        color: #6c757d !important;
                      }
                      .hover-group:hover svg {
                        stroke: #6c757d;
                      }
                    `}
                  </style>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className='col-sm-4'>
          <div className='card gap-3' style={{ padding: '24px' }}>
            <h3 className='card-title'>
              <span className='fw-bold fs-4 text-dark'>Tests</span>
            </h3>
            <div>
              <div className='d-flex justify-content-end mb-3'>
                <div className='d-flex flex-column w-100'>
                  <div className='d-flex justify-content-end fs-7 text-black mb-1'>
                    <span className='fw-semibold'>
                      {totalTest !== 0 ? `${((passingTests / totalTest) * 100).toFixed(0)}%` : '0%'}{' '}
                      <span className='text-gray-800'>Passing</span>
                    </span>
                  </div>
                  <div
                    className='h-12px w-100 rounded'
                    style={{ backgroundColor: 'rgb(229 231 235)' }}
                  >
                    <div
                      className='rounded h-8px'
                      role='progressbar'
                      style={{
                        width:
                          totalTest !== 0 ? `${Math.min(passingTests / totalTest) * 100}%` : '0%',
                        backgroundColor: '#0E9F6E',
                      }}
                      aria-valuenow={
                        totalTest !== 0 ? Math.min((passingTests / totalTest) * 100, 100) : 0
                      }
                      aria-valuemin={0}
                      aria-valuemax={100}
                    ></div>
                  </div>
                </div>
              </div>
              <div className='d-flex justify-content-between align-items-center mt-6'>
                <div className='d-flex align-items-center'>
                  <svg
                    xmlns='http://www.w3.org/2000/svg'
                    width='18'
                    height='18'
                    viewBox='0 0 24 24'
                    fill='none'
                    stroke='currentColor'
                    stroke-width='2'
                    stroke-linecap='round'
                    stroke-linejoin='round'
                    className='icon icon-tabler icons-tabler-outline icon-tabler-list-check me-2'
                  >
                    <path stroke='none' d='M0 0h24v24H0z' fill='none' />
                    <path d='M3.5 5.5l1.5 1.5l2.5 -2.5' />
                    <path d='M3.5 11.5l1.5 1.5l2.5 -2.5' />
                    <path d='M3.5 17.5l1.5 1.5l2.5 -2.5' />
                    <path d='M11 6l9 0' />
                    <path d='M11 12l9 0' />
                    <path d='M11 18l9 0' />
                  </svg>
                  <span className='text-gray-700 fw-semibold'>Total Tests</span>
                </div>
                <span className='text-gray-900 fw-bold'>{totalTest}</span>
              </div>

              <div className='d-flex justify-content-between align-items-center mt-4'>
                <div className='d-flex align-items-center'>
                  <svg
                    xmlns='http://www.w3.org/2000/svg'
                    width='18'
                    height='18'
                    viewBox='0 0 24 24'
                    fill='none'
                    stroke='#EE3043'
                    strokeWidth='2'
                    strokeLinecap='round'
                    strokeLinejoin='round'
                    className='me-2'
                  >
                    <path stroke='none' d='M0 0h24v24H0z' fill='none' />
                    <path d='M3 12a9 9 0 1 0 18 0a9 9 0 0 0 -18 0' />
                    <path d='M12 8v4' />
                    <path d='M12 16h.01' />
                  </svg>
                  <span className='text-gray-700 fw-semibold'>Failing</span>
                </div>
                <span className='text-gray-900 fw-bold'>{failingTests}</span>
              </div>

              <div className='d-flex justify-content-between align-items-center mt-4'>
                <div className='d-flex align-items-center hover-group' style={{ cursor: 'pointer' }}>
                  <Link
                    to='/tests'
                    className='text-dark fw-medium text-decoration-underline hover-text hover-text-decoration-underline me-1'
                  >
                    View tests
                  </Link>
                  <svg
                    xmlns='http://www.w3.org/2000/svg'
                    width='14'
                    height='14'
                    viewBox='0 0 24 24'
                    fill='none'
                    stroke='currentColor'
                    strokeWidth='2'
                    strokeLinecap='round'
                    strokeLinejoin='round'
                    className='icon icon-tabler icons-tabler-outline icon-tabler-chevron-right transition-transform hover-effect'
                    style={{ transition: 'transform 0.2s ease-in-out' }}
                  >
                    <path stroke='none' d='M0 0h24v24H0z' fill='none' />
                    <path d='M9 6l6 6l-6 6' />
                  </svg>
                  <style>
                    {`
                      .hover-group:hover .hover-effect {
                        transform: translateX(3px);
                      }
                      .hover-group:hover .hover-text {
                        color: #6c757d !important;
                      }
                      .hover-group:hover svg {
                        stroke: #6c757d;
                      }
                    `}
                  </style>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className='col-sm-4'>
          <div className='card gap-3' style={{ padding: '24px' }}>
            <h3 className='card-title'>
              <span className='fw-bold fs-4 text-dark'>Policies</span>
            </h3>
            <div>
              <div className='d-flex justify-content-end mb-3'>
                <div className='d-flex flex-column w-100'>
                  <div className='d-flex justify-content-end fs-7 text-black mb-1'>
                    <span className='fw-semibold'>
                      {totalPolicy !== 0
                        ? `${((totalPolicyApproval / totalPolicy) * 100).toFixed(0)}%`
                        : '0%'}{' '}
                      <span className='text-gray-800 '>Completed</span>
                    </span>
                  </div>
                  <div
                    className='h-12px w-100 rounded'
                    style={{ backgroundColor: 'rgb(229 231 235)' }}
                  >
                    <div
                      className='rounded h-8px'
                      role='progressbar'
                      style={{
                        width:
                          totalPolicy !== 0
                            ? `${Math.min(totalPolicyApproval / totalPolicy) * 100}%`
                            : '0%',
                        backgroundColor: '#0E9F6E',
                      }}
                      aria-valuenow={
                        totalPolicy !== 0
                          ? Math.min((totalPolicyApproval / totalPolicy) * 100, 100)
                          : 0
                      }
                      aria-valuemin={0}
                      aria-valuemax={100}
                    ></div>
                  </div>
                </div>
              </div>
              <div className='d-flex justify-content-between align-items-center mt-6'>
                <div className='d-flex align-items-center'>
                  <svg
                    xmlns='http://www.w3.org/2000/svg'
                    width='18'
                    height='18'
                    viewBox='0 0 24 24'
                    fill='none'
                    stroke='#5E6274'
                    stroke-width='2'
                    stroke-linecap='round'
                    stroke-linejoin='round'
                    className='me-2'
                  >
                    <path d='M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7Z' />
                    <path d='M14 2v4a2 2 0 0 0 2 2h4' />
                    <path d='M10 9H8' />
                    <path d='M16 13H8' />
                    <path d='M16 17H8' />
                  </svg>
                  <span className='text-gray-700 fw-semibold'>Total Policies</span>
                </div>
                <span className='text-gray-900 fw-bold'>{totalPolicy}</span>
              </div>

              <div className='d-flex justify-content-between align-items-center mt-4'>
                <div className='d-flex align-items-center'>
                  <svg
                    xmlns='http://www.w3.org/2000/svg'
                    width='18'
                    height='18'
                    viewBox='0 0 24 24'
                    fill='none'
                    stroke='#EE3043'
                    strokeWidth='2'
                    strokeLinecap='round'
                    strokeLinejoin='round'
                    className='me-2'
                  >
                    <path stroke='none' d='M0 0h24v24H0z' fill='none' />
                    <path d='M3 12a9 9 0 1 0 18 0a9 9 0 0 0 -18 0' />
                    <path d='M12 8v4' />
                    <path d='M12 16h.01' />
                  </svg>
                  <span className='text-gray-700 fw-semibold'>Incomplete</span>
                </div>
                <span className='text-gray-900 fw-bold'>{totalPolicy - totalPolicyApproval}</span>
              </div>

              <div className='d-flex justify-content-between align-items-center mt-4'>
                <div className='d-flex align-items-center hover-group' style={{ cursor: 'pointer' }}>
                  <Link
                    to='/policy-library/lists'
                    className='text-dark fw-medium text-decoration-underline hover-text hover-text-decoration-underline me-1'
                  >
                    View policies
                  </Link>
                  <svg
                    xmlns='http://www.w3.org/2000/svg'
                    width='14'
                    height='14'
                    viewBox='0 0 24 24'
                    fill='none'
                    stroke='currentColor'
                    strokeWidth='2'
                    strokeLinecap='round'
                    strokeLinejoin='round'
                    className='icon icon-tabler icons-tabler-outline icon-tabler-chevron-right transition-transform hover-effect'
                    style={{ transition: 'transform 0.2s ease-in-out' }}
                  >
                    <path stroke='none' d='M0 0h24v24H0z' fill='none' />
                    <path d='M9 6l6 6l-6 6' />
                  </svg>
                  <style>
                    {`
                      .hover-group:hover .hover-effect {
                        transform: translateX(3px);
                      }
                      .hover-group:hover .hover-text {
                        color: #6c757d !important;
                      }
                      .hover-group:hover svg {
                        stroke: #6c757d;
                      }
                    `}
                  </style>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* )} */}
        {/*end::Col*/}

        {/* {activeFrameworks.length === 0 ? (
          <div className="col d-flex align-items-stretch mb-5 mb-xl-10">
            <div
              className="card d-flex text-start p-6 border-dashed"
              style={{
                backgroundColor: "#E8F4F0",
                borderColor: "#50cd89",
              }}
            >
              <span className="d-flex align-items-center">
                <span className="ms-4">
                  <span className="d-flex justify-content-between align-items-center fs-5 fw-bold text-gray-900 mb-2">
                    <span>Get Started with SecureSlate</span>
                    {isLoading && (
                      <span className="fs-7 text-gray-600">
                        Account Setup in Progress...{" "}
                        <div
                          className="spinner-border spinner-border-sm"
                          role="status"
                          style={{ color: "#0E9F6E" }}
                        >
                          <span className="visually-hidden">Loading...</span>
                        </div>
                      </span>
                    )}
                  </span>
                  <span className="fw-semibold fs-6 text-gray-700">
                    It looks like you haven't purchased a SecureSlate plan yet.
                    To unlock powerful security features and expand your
                    capabilities, explore our
                    <a
                      href="https://getsecureslate.com/pricing"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="text-primary ms-1 fw-semibold"
                    >
                      Pricing Page{" "}
                    </a>
                    and find the best plan for your business. You can also
                    <a
                      href="#"
                      onClick={() => toggleCrispChat()}
                      className="text-primary ms-1 fw-semibold"
                    >
                      contact our sales team{" "}
                    </a>
                    for personalized recommendations.
                  </span>
                </span>
              </span>
            </div>
          </div>
        ) : (
          <>
            {activeFrameworks.includes("ISO 27001:2022") &&
              renderFrameworkCard("ISO 27001:2022")}
            {activeFrameworks.includes("SOC 2") && renderFrameworkCard("SOC 2")}
          </>
        )} */}

        {/* {activeFrameworks.includes('ISO 27001:2022') && renderFrameworkCard('ISO 27001:2022')}
        {activeFrameworks.includes('SOC 2') && renderFrameworkCard('SOC 2')} */}
      </div>
    </>
  )
}

export default DashboardHeader
